<template>
  <div class="exhibitionsItem">
    <MobileHead />
    <div class="loop">
      <loopImg />
    </div>
    <div class="productContent">
      <div class="main">
        <div class="breadcrumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }" class="home">{{ $t('navbar.home') }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ $t('navbar.exhibits') }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
    </div>
    <div class="exhibitonScreen">
      <div class="goldBox">
        <div class="title">{{ $t('homePage.quickFind2') }}</div>
        <div class="search">
          <div class="row1">
            <div class="searchBox">
              <el-input v-model="keyWords" :placeholder="$t('homePage.placeholder2')"></el-input>
            </div>
            <div class="btn">
              <el-button icon="el-icon-search" @click="searchClick()">{{ $t('homePage.search') }}</el-button>
            </div>
          </div>
          <div class="row2">
            <div class="selecTree">
              <div class="inputSelect" @click="openPanel">
                <span v-if="!selectProductType">{{ $t('common.screen1') }}</span>
                <span v-else>{{ selectProductType }}</span>
                <i class="el-icon-arrow-down" v-if="!selectvisible"></i>
                <i class="el-icon-arrow-up" v-else></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="productLists" id="proTypeCard">
        <el-drawer :visible="selectvisible" width="100%" direction="btt" :with-header="false" :before-close="handleClose1">
          <el-tabs tab-position="left">
            <el-tab-pane v-for="(item, index) in screenList.conditons" :key="index" class="tabItem">
              <span slot="label">
                <el-checkbox @change="checkFirst(item)" v-model="item.choose">{{ item.title }}</el-checkbox>
              </span>
              <el-collapse v-model="activeNames" @change="handleChange" accordion>
                <el-collapse-item :name="kk" v-for="(ii, kk) in item.children" :key="kk">
                  <template slot="title">
                    <el-checkbox @change="checkSecond(ii, item)" v-model="ii.choose">{{ ii.title }}</el-checkbox>
                  </template>
                  <div>
                    <el-checkbox @change="checkThird(ii, i, item)" v-model="i.choose" v-for="(i, k) in ii.children" :key="k">{{ i.title }}</el-checkbox>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-tab-pane>
          </el-tabs>
          <div class="bottom">
            <div class="btn" @click="submit">{{ $t('common.sure') }}</div>
          </div>
        </el-drawer>
      </div>
      <div class="screenTag">
        <div class="rightTitle" :style="{ display: dynamicTags.length > 0 ? 'block' : 'none' }">
          <!--筛选条件框-->
          <el-row class="selectt">
            <div class="text">{{ $t('common.screenConditions') }}</div>
            <!--tags标签 -->
            <div>
              <el-tag :key="k" v-for="(tag, k) in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)">
                {{ tag.name }}
              </el-tag>
            </div>
            <!-- 清空按钮 -->
            <div class="clear">
              <el-button icon="el-icon-delete" type="primary" @click="clearTag()">{{ $t('common.clear') }}</el-button>
            </div>
          </el-row>
        </div>
      </div>
      <div class="rightContent" :style="{ marginTop: dynamicTags.length > 0 ? '20px' : '0' }" v-if="RecommendExhibits.length > 0">
        <!-- 右侧内容区域的子栏目开始 -->
        <div v-for="(item, k) in RecommendExhibits" :key="k" class="rightBox" @click="goDetail(item.id)">
          <div>
            <div class="fixHigh">
              <div class="titl comment">{{ item.exhibitsName }}</div>
              <div class="english comment">{{ item.column23 }}</div>
              <div class="txt">{{ item.column17 }}</div>
            </div>
            <div class="backImg">
              <img :src="item.exhibitsCoverImg" alt="" v-if="item.exhibitsCoverImg.substr(0,4) == 'http'" />
              <img src="../../../static/占位-展品-列表.png" alt="" v-else />
            </div>
            <div class="companyName">
              <span class="leftTitle">{{ lang== 'zh' ? item.hzExhibitor.companyNameC :  item.hzExhibitor.companyNameE }}</span>
            </div>
          </div>
          <div class="bottom">
            <div class="bottomLeft" @click.stop="consult(item)">
              {{ $t('common.talk') }}
            </div>
            <div class="bottomRight" @click.stop="toggle(item)">
              {{ item.collectStatus ? $t('common.cancel') : $t('common.favorites') }}
            </div>
          </div>
        </div>

        <!-- 右侧内容区域的子栏目结束  -->
      </div>
      <!-- 筛选提交为空 -->
      <div class="boxImg" v-else>
        <img src="../../../static/empty.png" alt="" />
        <div>{{ $t('exhibition.noexhibition') }}</div>
      </div>
      <div class="pagination">
        <el-pagination
          v-if="pageshow"
          class="explore_right_pages"
          layout="prev, pager, next"
          :current-page="currentPage4"
          @current-change="handleCurrentChange"
          :page-size="18"
          :total="countALL"
        >
        </el-pagination>
      </div>
      <Foot />
      <GoLogin :dialogVisible.sync="dialogVisible" @func="getMsgFormSon" @funcancel="getCancel" />
    </div>
  </div>
</template>

<script>
import MobileHead from '../../../common/mobile/head.vue';
import loopImg from './loopImg.vue';
import { screenList } from '../../../../Json/screenList.js';
import { screenListEn } from '../../../../Json/screenListEn.js';
import { searchExhibits, collecExhibit } from '../../../../api/exhibitProduct.js';
import { forMat } from '../../../../utils/common';
import Foot from '../../../common/mobile/footBottom.vue';
import GoLogin from '../../../common/mobile/goLogin.vue'; //登录提示框
import * as tools from '../../../../utils/roulink';

export default {
  name: '',
  components: { MobileHead, loopImg, Foot, GoLogin },

  data() {
    return {
      baseUrl: forMat(),
      selectProductType: '',
      selectvisible: false,
      screenList: null,
      activeNames: [0],
      dynamicTags: [],
      keyWords: '',
      RecommendExhibits: [],
      countALL: 1,
      currentPage4: 1,
      pageshow: true,
      dialogVisible: false,
      lang: "zh",
    };
  },
  created() {
    document.documentElement.scrollTop = 0;
    window.scrollTo(0, 0);
    this.lang = localStorage.getItem('lang');
    if (this.lang == 'en') {
      this.screenList = screenListEn;
    } else {
      this.screenList = screenList;
    }
    const href = window.location.href;
    const type = this.getQueryString('type');
    if (type) {
      const arr = type.split(',');
      arr.map((item) => {
        this.screenList.conditons.map((i) => {
          if (decodeURIComponent(item) === i.type) {
            i.choose = true;
            this.dynamicTags.push({ index: i.id, name: i.title, type: i.type });
          }
        });
      });
    } else if (href.includes('?')) {
      const arr = decodeURI(href).split('?');
      const newArr = arr[1].split('&');
      // 类型
      let type;
      if (newArr[0].includes('=')) {
        type = newArr[0].split('=');
        if (type[1] == '') {
          type = '';
        }
      } else {
        type = '';
      }
      let keyword;
      // 关键字
      if (newArr[1]) {
        keyword = newArr[1].split('=')[1];
      } else {
        keyword = '';
      }
      if (type != '') {
        const params = {
          page: 1,
          size: 18,
          value: {
            exhibitsType: type,
            keyword: keyword,
          },
        };
        this.getSearchData(params);
      } else {
        const params = {
          page: 1,
          size: 18,
          value: {
            keyword: keyword,
          },
        };
        console.log('执行的展品无类型的数据的查询');
        this.getSearchData(params);
      }
    } else {
      this.initData();
    }
  },
  methods: {
    handleClose1() {
      this.selectvisible = false;
    },
    getQueryString(query) {
      const obj = this.$router.history.current.query;
      if (obj[query]) {
        return obj[query];
      } else {
        return '';
      }
    },
    initData() {
      const params = {
        page: 1,
        size: 18,
        value: {
          exhibitsType: [],
          keyword: '',
        },
      };
      this.getSearchData(params);
    },

    async getSearchData(params) {
      const { data } = await searchExhibits(params);
      this.countALL = data.data.count;
      if (data.data.list?.length > 0) {
        this.RecommendExhibits = data.data.list;

        this.countALL = data.data.count;
      } else {
        this.RecommendExhibits = [];
      }
    },
    async searchClick() {
      // 点击搜索按钮进行搜索
      var exhibitsType = [];
      if (this.dynamicTags.length > 0) {
        this.dynamicTags.map((item) => {
          exhibitsType.push(item.type);
        });
      }
      const params = {
        page: 1,
        size: 18,
        value: {
          exhibitsType: exhibitsType,
          keyword: this.keyWords,
        },
      };
      this.getSearchData(params);
    },
    handleCurrentChange(val) {
      document.documentElement.scrollTop = 0;
      window.scrollTo(0, 0);
      var exhibitsType = [];
      if (this.dynamicTags.length > 0) {
        this.dynamicTags.map((item) => {
          exhibitsType.push(item.type);
        });
      }
      const params = {
        page: val,
        size: 18,
        value: {
          exhibitsType: exhibitsType,
          keyword: this.keyWords,
        },
      };
      this.getSearchData(params);
    },
    openPanel() {
      this.selectvisible = true;
    },
    submit() {
      this.selectvisible = false;
    },
    checkFirst(i) {
      this.deSelect(i);
    },

    checkSecond(item, first) {
      if (item.choose) {
        item.children.map((item) => {
          item.choose = true;
          this.dynamicTags.push({
            index: item.id,
            name: item.title,
            type: item.type,
            currentIndex: first.currentIndex,
          });
          this.dynamicTags = this.unique(this.dynamicTags);
        });
      } else {
        item.children.forEach((i) => {
          i.choose = false;
          const index = this.dynamicTags.findIndex((k) => {
            return i.title == k.name;
          });
          this.dynamicTags.splice(index, 1);

          this.dynamicTags = this.unique(this.dynamicTags);
        });
      }
    },
    unique(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.name) && res.set(arr.name, 1));
    },
    checkThird(arr, item, first) {
      if (item.choose) {
        this.dynamicTags.push({
          index: item.id,
          name: item.title,
          type: item.type,
          currentIndex: first.currentIndex,
        });

        const flag = arr.children.every((i) => {
          return i.choose == true;
        });
        flag ? (arr.choose = true) : console.log('');
      } else {
        const index = this.dynamicTags.findIndex((i) => {
          return i.name == item.title;
        });
        this.dynamicTags.splice(index, 1);
        const flag = arr.children.some((i) => {
          return i.choose == true;
        });
        flag ? (arr.choose = false) : console.log('');
      }
    },
    //取消选择
    deSelect(i) {
      if (i.choose) {
        i.title.length > 2
          ? this.dynamicTags.push({
              index: i.id,
              name: i.title,
              type: i.type,
              currentIndex: i.currentIndex,
            })
          : this.dynamicTags.push({
              index: i.id,
              name: i.title + this.$t('common.hall'),
            });
      } else {
        for (let item in this.dynamicTags) {
          i.id == this.dynamicTags[item].index ? this.dynamicTags.splice(item, 1) : console.log('失败');
        }
      }
    },

    //tags删除取消事件
    handleClose(tag) {
      this.matchTag(tag.name, this.screenList.conditons);
      this.tagDel(tag);
      this.matchTree(tag.name, this.screenList.conditons[tag.currentIndex].children);
    },
    matchTree(tag, arr) {
      for (let i = 0; i < arr.length; i++) {
        arr[i].children.map((item) => {
          if (tag == item.title) {
            item.choose = false;
            arr[i].choose = false;
            return false;
          }
        });
      }
    },
    //tag标签删除
    tagDel(tag) {
      const i = this.dynamicTags.findIndex((item) => {
        return item.index == tag.index;
      });
      this.dynamicTags.splice(i, 1);
    },
    //tags左侧匹配事件
    matchTag(val, arr) {
      for (let i = 0; i < arr.length; i++) {
        if (val == arr[i].title) {
          arr[i].choose = false;
          return false;
        }
      }
    },
    clearTag() {
      this.dynamicTags = [];
      //清空按产品类型筛选
      this.screenList.conditons.forEach((element) => {
        element.choose = false;
        element.children.forEach((i) => {
          i.choose = false;
          i.children.forEach((v) => {
            v.choose = false;
          });
        });
      });

      this.secordList.forEach((item) => {
        item.choose = false;
        item.children.forEach((i) => {
          i.choose = false;
        });
      });
    },
    handleChange() {},
    goDetail(id) {
      this.$router.push({
        name: 'exhibItem_detail',
        query: {
          id,
        },
      });
    },
    consult(item) {
      const viewToken = localStorage.getItem('viewToken');
      const token = localStorage.getItem('token');
      if (!viewToken) {
        this.dialogVisible = true;
      }
      if (viewToken) {
        tools.login(1, item.hzExhibitorId);
      }
      if (token && !viewToken) {
        this.$message({
          showClose: true,
          message: this.$t('message.isLimit'),
          type: 'error',
        });
        return;
      }
    },
    // 切换产品的收藏
    async toggle(item) {
      const willStatus = !item.collectStatus;
      // 添加或者取消收藏
      const params = {
        objId: item.id,
        flag: willStatus,
        type: 2,
      };
      // const toggleStatus = item.collectStatus === true ? true : false;
      try {
        const { data } = await collecExhibit(params);
        if (data.code === 200) {
          if (!item.collectStatus) {
            item.collectStatus = !item.collectStatus;
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
          } else {
            item.collectStatus = !item.collectStatus;
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'error',
            });
          }
        } else {
          // this.$message({
          //   showClose: true,
          //   message: data.msg,
          //   type: 'warning',
          // });
          // tools.login(3);
        }
      } catch (err) {
        if (err == 'noLogin') {
          this.dialogVisible = true;
        }
      }
    },
    getMsgFormSon(data) {
      this.dialogVisible = data;
      tools.login(3);
    },
    getCancel(data) {
      this.dialogVisible = data;
    },
  },
  watch: {
    keyWords(newValue, oldValue) {
      this.keyWords = newValue;
    },
    dynamicTags(newValue, oldValue) {
      var exhibitsType = [];
      newValue.map((item) => {
        exhibitsType.push(item.type);
      });
      const params = {
        page: 1,
        size: 18,
        value: {
          exhibitsType: exhibitsType,
          keyword: this.keyWords,
        },
      };
      this.currentPage4 = 1;
      this.pageshow = false;
      this.getSearchData(params);
      this.$nextTick(() => {
        this.pageshow = true;
      });
      const type = exhibitsType.toString();
      const href = window.location.href;
      if (newValue.length == 0) {
        const href = window.location.href;
        const arr = href.split('?');
        window.location.href = arr[0];
      } else {
        const arr = href.split('?')[0];
        window.location.href = arr + '?type=' + type;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.exhibitionsItem {
  .loop {
    margin-top: 13.3vw;
  }

  .productContent {
    .main {
      padding-top: 23px;
      box-sizing: border-box;
      margin: 0 auto;
      .breadcrumb {
        padding-left: 4vw;
        box-sizing: border-box;
        a {
          color: #006fb8;
        }
      }
    }
  }
  .exhibitonScreen {
    .goldBox {
      width: 100%;
      margin-top: 4vw;
      padding-left: 4vw;
      padding-right: 4vw;
      box-sizing: border-box;

      .title {
        font-size: 4.8vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333;
        text-align: center;
        box-shadow: 0px 0px 6.8vw 0px #e8ecf0;
        padding: 4vw 0 3.3vw 0px;
        box-sizing: border-box;
        z-index: 20;
        color: #006fb8;
        background: #facd00;
      }

      //搜索框
      .search {
        padding: 0 2.6vw;
        padding-bottom: 5.3vw;
        box-sizing: border-box;
        height: 28.5vw;
        background: #facd00;
        .row1 {
          display: flex;
          .searchBox {
            width: 60vw;
          }

          //右侧的蓝色按钮
          .btn {
            width: 24vw;
            margin-left: 2.6vw;

            .el-button {
              width: 100%;
              background: #006fb8;
              font-size: 4.3vw;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
              height: 9.6vw;
              background: #006fb8;
              border-radius: 1vw;
              line-height: 9.6vw;
              padding: 0;
              box-sizing: border-box;

              .el-icon-search:before {
                font-size: 3.3vw !important;
              }
            }
          }
        }
        .row2 {
          display: flex;
          margin-top: 4vw;
          .selecTree {
            width: 100vw;
            .inputSelect {
              width: 100%;
              -webkit-appearance: none;
              background-color: #fff;
              border-radius: 4px;
              border: 1px solid #dcdfe6;
              height: 9.6vw;
              line-height: 9.6vw;
              padding: 0 8vw 0 4vw;
              box-sizing: border-box;
              transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
              width: 100%;
              font-size: 3.7vw;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #999999;
              position: relative;
              overflow: hidden;
              i {
                position: absolute;
                right: 0;
                top: 0;
                line-height: 11.2vw;
                height: 100%;
                width: 25px;
                text-align: center;
                transition: all 0.3s;
                line-height: 11.2vw;
              }
            }

            .el-select {
              width: 100%;
            }
          }
        }

        //右边的输入框以及按钮
      }
    }
    .productLists {
      .bottom {
        width: 100%;
        height: 15%;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(109, 109, 109, 0.35);
        position: relative;
        padding-right: 6.4vw;
        box-sizing: border-box;
        .btn {
          width: 24vw;
          height: 9.6vw;
          background: #006fb8;
          border-radius: 1vw;
          line-height: 9.6vw;
          text-align: center;
          font-size: 4.2vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          float: right;
          position: relative;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    .screenTag {
      margin-top: 7.2vw;
      padding-left: 4vw;
      padding-right: 4vw;
      box-sizing: border-box;
      .selectt {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .text {
          margin-bottom: 2.5vw;
        }
        .el-button--primary {
          border-radius: 0.5vw;
          text-align: center;
          width: 16.9vw;
          height: 7.7vw;
          background: #006fb8;
          border-radius: 1vw;
          line-height: 7.7vw;
          text-align: center;
          font-size: 4.2vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          padding: 0;
          box-sizing: border-box;
          font-size: 3.2vw;
          font-family: Microsoft YaHei;
        }
        .disp {
          margin-left: 1.3vw;
        }
        .clear {
          margin-left: 1.3vw;
          button {
            // margin-bottom: 1.2vw;
          }
        }
      }
    }
    .rightContent {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding-left: 4vw;
      padding-right: 4vw;
      box-sizing: border-box;
      .emptyStyle {
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 300px;
        position: relative;
        .promptInfo {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          position: absolute;
          top: 135px;
          left: 450px;
        }
      }
      .rightBox {
        width: 44vw;
        height: 70.1vw;
        // border: 1px solid rgb(0, 8, 255);
        background-color: white;
        margin-bottom: 3.7vw;
        border: 1px solid #e0e0e0;
        .fixHigh {
          height: 16.9vw;
          .titl {
            font-size: 4.3vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            margin-top: 4.5vw;
            margin-left: 3.2vw;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            word-break: break-all;
            max-width: 33.3vw;
          }
          .english {
            font-size: 2.6vw;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333333;
            margin-top: 1.2vw;
            margin-left: 3.2vw;
            line-height: 3.6vw;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            max-width: 33.3vw;
          }
          .txt {
            font-size: 2.6vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            margin-top: 1.3vw;
            margin-left: 3.2vw;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            line-height: 3.6vw;
            max-width: 33.3vw;
          }
        }

        .backImg {
          width: 100%;
          height: 27.9vw;
          padding: 0px 3.2vw 0px 3.2vw;
          box-sizing: border-box;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .companyName {
          padding: 0px 3.2vw 0px 3.2vw;
          box-sizing: border-box;
          margin-top: 2.6vw;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          position: relative;
          padding-bottom: 4vw;
          box-sizing: border-box;
          border-bottom: 1px solid #e0e0e0;
          .leftTitle {
            font-size: 2.6vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            width: 37.1vw;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 37.1vw;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .bottom::after {
          content: '';
          display: block;
          height: 0;
          visibility: hidden;
          clear: both;
        }
        .bottom {
          padding-top: 2.1vw;
          padding-left: 3.2vw;
          padding-right: 3.2vw;
          box-sizing: border-box;
          width: 100%;
          .bottomLeft,
          .bottomRight {
            margin-top: 1.3vw;
            box-sizing: border-box;
            float: left;
            font-size: 3.2vw;
            cursor: pointer;
            color: #006fb8;
            font-family: Microsoft YaHei;
            font-weight: 400;
            text-align: center;
          }
          .bottomLeft {
            border-right: 1px solid #ccc;
            width: 50%;
          }
          .bottomRight {
            width: 50%;
            float: right;
            display: flex;
            overflow: hidden;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            // width: 18vw;
          }
        }
      }
    }
    .rightContent .rightBox:nth-child(2n) {
      margin-right: 0;
    }
    .pagination {
      display: flex;
      justify-content: center;
      margin: 2.6vw 0 8vw;
      span {
        font-size: 1.6vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        margin-top: 1.2vw;
      }
    }
  }
}
</style>
<style scoped lang="scss">
.el-dialog {
  text-align: center;
}
::v-deep .explore_right_pages {
  display: flex;
  align-items: center;
  justify-content: center;
  .el-pagination button:hover {
    color: #978d8d;
  }
  .el-pagination button {
    color: #999999;
  }

  .el-pager li {
    background-color: unset;
    vertical-align: middle;
    min-width: 5.3vw;
    padding: 0;
    box-sizing: border-box;
  }
  .el-pager li:hover {
    color: #999999;
  }
  .btn-prev {
    width: 5.3vw;
    height: 5.3vw;
    line-height: 5.3vw;
    color: #333;
    font-size: 2.1vw;
    background: #fff;
    border-radius: 0.5vw;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 0.7vw;
    margin-left: 1.3vw;
  }

  .btn-next {
    width: 5.3vw;
    height: 5.3vw;
    line-height: 5.3vw;
    color: #333;
    font-size: 2.1vw;
    background: #fff;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 0.7vw;
  }
  .el-pager .number {
    width: 5.3vw;
    height: 5.3vw;
    line-height: 5.3vw !important;
    border-radius: 0.5vw;
    border: 1px solid #cccccc;
    margin-right: 1vw;
    color: #333;
    font-size: 2.1vw;
    font-family: Microsoft YaHei;
    font-weight: 400;
    background: #fff;
  }
  .el-pager .number:hover {
    color: #006fb8;
  }
  .el-pager li.active {
    width: 5.3vw;
    height: 5.3vw;
    line-height: 5.3vw !important;
    border: 1px solid #007cc2;
    cursor: pointer;
    background: #006fb8;
    font-size: 2.1vw;
    font-weight: 400;
    color: #fff;
    font-family: Microsoft YaHei;
  }
  .el-pager li.active:hover {
    color: #fff;
    background: #006fb8;
  }
  .el-pager li.btn-quicknext {
    line-height: 3.7vw;
    color: #999;
  }
}
</style>
<style scoped>
.el-tag {
  margin-left: 2.6vw !important;
  margin-top: 1vw;
  margin-bottom: 1.6vw !important;
  height: 7.7vw !important;
  line-height: 7.7vw !important;
}
.el-dialog__wrapper >>> .el-dialog__footer {
  text-align: center;
}
.dialog-footer >>> .el-button--primary {
  width: 28.8vw;
  height: 9.6vw;
  background: #006fb8;
  border-radius: 1vw;
}
.el-dialog__wrapper >>> .el-dialog {
  width: 66.67vw !important;
  /* height: 75.47vw; */
  background: #ffffff;
}
>>> .el-dialog__headerbtn {
  color: #312c2b;
  font-size: 2.93vw;
}
</style>
<style scoped>
.el-drawer__wrapper >>> .el-drawer {
  height: 70% !important;
  /* position: fixed;
  -webkit-transform: translateZ(0);
  transform: translateZ(0); */
}
.el-drawer__wrapper >>> .el-drawer__body {
  height: 85%;
}
.el-tabs--left >>> .el-tabs__item.is-left {
  text-align: left;
  max-height: 10vw;
  font-size: 3.2vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  width: 100%;
  margin-top: 3vw;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
  white-space: pre-wrap;
  flex-direction: column;
  justify-content: center;
  display: flex;
}
.el-tabs >>> .el-tabs__header {
  width: 39.2%;
  margin: 0;
}
.el-tabs >>> .el-tabs__content {
  padding-top: 5.3vw;
  padding-bottom: 5.3vw;
  box-sizing: border-box;
  height: 100%;
}
.el-tabs {
  height: 85%;
}
.el-drawer__wrapper >>> .el-tabs__active-bar {
  background-color: transparent !important;
}
.el-collapse {
  border-top: 0px;
}
.el-checkbox >>> .el-checkbox__label {
  white-space: normal;
  vertical-align: text-top;
}
.el-collapse-item >>> .el-collapse-item__wrap {
  background: #f6f6f7;
  overflow-y: scroll !important;
  /* max-height: 62vw; */
}
.el-collapse-item >>> .el-checkbox {
  height: 8vw;
  line-height: 4vw;
  font-size: 3.2vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 2vw;
  display: block;
}
.el-collapse-item >>> .el-collapse-item__content {
  padding-bottom: 0px;
  padding: 0px 4vw;
  box-sizing: border-box;
  width: 100%;
}
.el-collapse-item >>> .el-collapse-item__header {
  padding: 0px 4vw;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.exhibitionList .el-drawer__wrapper >>> .el-drawer {
  height: 52vw !important;
}
.boxImg {
  margin: 0 auto;
  text-align: center;
  font-size: 1.87vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}

.boxImg img {
  width: 50.67vw;
  height: 40vw;
}
.el-divider--vertical {
  margin: 0 auto;
}
.el-pagination >>> button {
  min-width: 5.3vw;
}
.pagination >>> .el-icon-arrow-right,
.pagination >>> .el-icon-arrow-left {
  color: #333;
}
.el-collapse-item >>> .el-collapse-item__header .el-checkbox__label {
  width: 40vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.el-tabs--left >>> .el-tabs__item.is-left .el-checkbox__label {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.el-tabs--left >>> .el-tabs__item.is-left .el-checkbox {
  display: flex;
}
.el-collapse-item >>> .el-collapse-item__content .el-checkbox__label {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  height: 8.5vw;
  line-height: 4.5vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.el-collapse-item >>> .el-collapse-item__content .el-checkbox {
  display: flex;
}
.el-collapse-item >>> .el-collapse-item__content {
  max-height: 60vw;
  overflow-y: scroll;
  padding-bottom: 5vw;
  box-sizing: border-box;
}
.breadcrumb >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #006fb8 !important;
  font-family: Microsoft YaHei;
}
.searchBox >>> .el-input__inner {
  height: 9.6vw;
  line-height: 9.6vw;
  font-size: 3.7vw;
}
>>> .el-checkbox__inner {
  vertical-align: middle;
}
.el-tabs__item .el-checkbox >>> .el-checkbox__label {
  font-size: 3.2vw;
}
.el-collapse-item .el-collapse-item__header .el-checkbox >>> .el-checkbox__label {
  font-size: 3.7vw;
}
.el-collapse-item__content .el-checkbox >>> .el-checkbox__label {
  font-size: 3.2vw;
}
.el-tabs--left >>> .el-tabs__nav-wrap.is-left.is-scrollable {
  padding-top: 4vw;
  padding-bottom: 4vw;
  box-sizing: border-box;
}
.el-tabs--left >>> .el-tabs__nav-wrap.is-left::after {
  width: 1px;
  margin-right: 0px;
}
>>> .el-tabs__item.is-active {
  background: #f4f4f4 !important;
  color: #006fb8 !important;
}
.el-tabs >>> .el-tabs__nav-prev {
  display: none;
}
.el-tabs >>> .el-tabs__nav-next {
  display: none;
}
.el-tabs--left >>> .el-tabs__nav-scroll {
  overflow: scroll !important;
  /* overflow-y: hidden !important; */
  height: 100% !important;
}
.el-breadcrumb__item >>> .el-breadcrumb__inner {
  color: #333 !important;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
>>> .el-checkbox__input{
  line-height: inherit;
}
</style>
